const host = 'https://sync.rhx.it';

// const cors = 'https://cors-anywhere.herokuapp.com/';

export default {
  syncUrl: () => `${host}/sync`,
  homeUrl: () => `${host}/`,
  testUrl: () => `${host}/test`,
  tokenUrl: token => `${host}/apptokens/${token}`,
  tokenProgressUrl: token => `${host}/tokens/${token}`,
};
